module.exports = __webpack_public_path__ + "img/logo-main.f611eeaa.png";